<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="8">
        <ValidationObserver
          ref="emailForm"
          v-slot="{
            // eslint-disable-next-line vue/no-unused-vars
            invalid,
            // eslint-disable-next-line vue/no-unused-vars
            passes,
          }"
        >
          <v-row>
            <v-col class="justify-center mb-6">
              <v-img contain src="@/assets/logo_horizontal.svg" height="55"></v-img>
            </v-col>
          </v-row>
          <v-form rel="emailForm" @submit.prevent="passes(submitReset)">
            <v-card class="elevation-12">
              <v-card-title flat class="justify-center ma-6">
                <v-toolbar-title>Zapomenuté heslo</v-toolbar-title>
              </v-card-title>
              <v-card-text class="mb-0">
                <VTextFieldWithValidation
                  v-model="form.email"
                  rules="required|email"
                  outlined
                  dense
                  icon="mdi-account"
                  type="email"
                  label="E-mail"
                  data-cy="email"
                />
              </v-card-text>
              <v-card-actions class="pl-4 pr-4 pb-4">
                <v-btn
                  type="submit"
                  block
                  color="primary"
                  height="40px"
                  depressed
                  :loading="isLoggin"
                >
                  Odeslat
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-if="errorMessage" type="error" class="mt-4">
              {{ errorMessage }}
            </v-alert>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PasswordLost',
  data() {
    return {
      form: {
        email: '',
      },
      errorMessage: null,
      isLoggin: false,
    }
  },
  methods: {
    ...mapActions({
      passwordReset: 'user/passwordReset',
    }),
    submitReset() {
      if (!this.form.email.length) return

      this.errorMessage = null
      this.isLoggin = true
      this.passwordReset(this.form)
        .then(() => {
          this.$router.push({
            name: 'login',
          })
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message
        })
        .finally(() => {
          this.isLoggin = false
        })
    },
  },
}
</script>
